import { DynamicContentBlock, LanguageItem } from 'common.types'
import { Button } from 'components/Button/Button'
import { useOneStop } from 'hooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const DynamicContent: React.FC<{ data: DynamicContentBlock[] }> = ({
  data,
}) => {
  const { i18n } = useTranslation()
  const { isOneStop, goToMailInBallot, goToPlanToVote, updateRegistration } =
    useOneStop()
  const buttonWrapperStyle = { marginTop: 10, marginBottom: 20 }
  const paragraphStyle = {}

  return (
    <>
      {data.map((item) => {
        if (item.type === 'content') {
          return (
            <div
              style={{
                ...paragraphStyle,
                fontSize: item.small ? 12 : 'inherit',
              }}
              dangerouslySetInnerHTML={{ __html: item.content[i18n.language] }}
            />
          )
        }
        if (item.type === 'cta') {
          return (
            <div style={buttonWrapperStyle}>
              <Button
                label={item.content[i18n.language]}
                onClick={() => {
                  if (isOneStop) {
                    switch (item?.oneStopTarget) {
                      case 'ovr':
                        updateRegistration()
                        break
                      case 'mib':
                        goToMailInBallot()
                        break
                      case 'plan_polls':
                        goToPlanToVote('polls')
                        break
                      case 'plan_early':
                        goToPlanToVote('early')
                        break
                      case 'plan_return':
                        goToPlanToVote('return')
                        break
                    }
                    goToMailInBallot()
                  } else if (item.url) {
                    window.location.href = item.url
                  }
                }}
                fullWidth={false}
              />
            </div>
          )
        }
        return null
      })}
    </>
  )
}
